/** 
©2018 EdgeVerve Systems Limited (a fully owned Infosys subsidiary),
Bangalore, India. All Rights Reserved.
**/
import '@polymer/polymer/polymer-legacy.js';
import { html } from '@polymer/polymer/lib/utils/html-tag.js';
window.appendBasicThemeToHead = function () {
  const template = html`
<custom-style>
<style is="custom-style">

  /*
   Polymer includes a shim for CSS Custom Properties that we can use for application theming.
   Below, you'll find the default palette for the Polymer Starter Kit layout. Feel free to play
   with changing the colors used or generate your own palette of colours at MaterialPalette.com.

   See https://www.polymer-project.org/1.0/docs/devguide/styling.html#xscope-styling-details
   for further information on custom CSS properties.
   */

  /* Application theme */

 html {

    /*
     * You can use these generic variables in your elements for easy theming.
     * For example, if all your elements use '--primary-text-color' as its main
     * color, then switching from a light to a dark theme is just a matter of
     * changing the value of '--primary-text-color' in your application.
     */

/*New UI Color Values*/
        /*--brand-color: rgb(0, 206, 255);                /*Branding theme color*/
        --brand-color: #002663;                /*Branding theme color COOP*/
        --secondary-brand-color: #046ab8;                /*Used in burger menu selected*/
        /*--primary-color-but: rgb(254, 88, 88);          /*Primary button color*/
        --primary-color-but: #367F14;          /*Primary button color*/
        --divider-color: rgba(0,0,0,0.15);              /*Divider color*/
        --divider-disabled-color: rgba(0,0,0,0.38);     /*Divider disabled color*/
        --background-primary: #F6F8F9;                   /*Used for body background*/
        --background-secondary: #F2F2F2;                  /*Used for other background*/
        --elevation-color: rgba(0,0,0, 0.12);             /*Used for other Elevation*/
        
        /*deprecated - incorrect spelling*/

        --background-primary: #F6F8F9;                   /*Used for body background*/
        --background-secondary: #F2F2F2;                  /*Used for other background*/      
      
        /*Card colors*/
        --card-color-1: #684073;
        --card-color-2: #26A69A;                
        --card-color-3: #00879D;
        --card-color-4: #5C6BC0;
        --card-color-5: #3C719D;
        --card-color-6: #445A65;
        /*Card colors*/
      
      
        /*Chart/Circle colors*/
       --chart-circle-color-light-1: #00BD9C;
       --chart-circle-color-light-2: #1FCE6D;
       --chart-circle-color-light-3: #2C97DE;
       --chart-circle-color-light-4: #9C56B8;
       --chart-circle-color-light-5: #F2C500;
       --chart-circle-color-light-6: #E87E04;
       --chart-circle-color-light-7: #E94B35;
      
      
      
       /* --chart-circle-color-dark-1: #00A185;
       --chart-circle-color-dark-2: #1AAF5D;
       --chart-circle-color-dark-3: #227FBB;
       --chart-circle-color-dark-4: #8F3FAF;
       --chart-circle-color-dark-5: #F59D00;
       --chart-circle-color-dark-6: #D55400;
       --chart-circle-color-dark-7: #C23824;*/
        /*Chart/Circle colors*/
      
      
        /*Notification color*/
        --critical-label-color: #E81D23;
        --warning-label-color: #FF7B00;
        --success-label-color: #5CB85C;             
        --info-label-color: #5BC0DE;                
        --outstanding-color: #FF5252;         
        /*Notification color
      
      
      
    
        /*used for font color values*/
        --primary-dark-color: rgba(0,0,0,0.87);        
        --secondary-dark-color: rgba(0,0,0,0.54);
        --disabled-dark-color: rgba(0,0,0,0.38);
        --backdrop-color: rgba(0,0,0,0.6);
      
        --button-text-shadow-color: rgba(0,0,0,.32);
      
        --primary-light-color: rgba(255,255,255,1);        
        --secondary-light-color: rgba(255,255,255,0.70);
        --disabled-light-color: rgba(255,255,255,0.50);
        --custom-secondary-color: #737373;
        /*used for font color values*/
    
          /*Flat Button COlor*/
          --flat-button-color: var(--brand-color);       
          /*Flat Button COlor*/
      
        /*Icons color*/
        --icons-default-color: var(--secondary-dark-color);    
        --icons-active-color: var(--primary-dark-color);
        /*Icons color*/
        
        
      
      /*Shadow elevation*/
      --shadow-elevation-1: 3px 2px 24px 0 rgba(0,0,0,0.09);    /*Used in card list box shadow*/
      
    
        --font-weight-light: 400;
        --font-weight-bold: 600;

        /*Font size for iphone*/
        /*--i-font-size-s: 13em;
        --i-font-size-m: 15em;
        --i-font-size-l: 17em;
        --i-font-size-xl: 32em;
        --i-font-size-xxxl: 45em;*/
        /*Font size for iphone*/
    
        /*Font size in em to support only new designs*/


        --body-font-size: .062em;
        --a-font-size-xxs: 0.4em;
        --a-font-size-xs: 0.8em;
        --a-font-size-s: 0.9em;
        --a-font-size-m: 1.0em;
        --a-font-size-l: 1.2em;
        --a-font-size-xl: 1.4em;
        --a-font-size-xxl: 1.6em;
        --a-font-size-xxxl: 2.0em;
        --a-button-font-size: 15px;
        --tooltip-font-size: 0.9em;
        /*Font size in em to support only new designs*/
      
          /*Font Family*/
            --regular-font: "COOPBank-Regular";
            --medium-font: "COOPBank-Regular";
            --thin-font: "COOPBank-Light";
            --light-font: "COOPBank-Light";
            --bold-font: "COOPBank-Bold";
          /*Font Family*/
      
      /*Text alignment*/
      --align-right: right;
      --align-left: left;
      /*Text alignment*/
      
      
        /*Font size in px to support both old and new designs*/   
       /* --a-font-size-xs: 11px;
        --a-font-size-s: 13px;
        --a-font-size-m: 15px;
        --a-font-size-l: 17px;
        --a-font-size-xl: 24px;
        --a-font-size-xxl: 36px;
        --a-font-size-xxxl: 45px;  
        --tooltip-font-size: 11px;*/ 
        /*Font size in px to support both old and new designs*/
    
        
      
        --card-bg: rgba(255,255,255,1);
      
      
      /*Corporate UI values*/
        --primary-color-100: #4E546C;        
        --primary-color-200: #3C425A;  
        --brand-color-50: #F0F7FF;
        --brand-color-100: #61b9df;         
        --brand-color-200: #0074CC;
        --brand-color-50: rgba(70, 169, 212, .04);
        --critical-color-100: #F07570; 
        --critical-color-200: #E3645F;
        --brand-color-grey: #E1E4E5;
        
            
      /*Corporate UI values*/
      
    /*New UI Color Values*/
}
</style>
</custom-style>`;
  template.setAttribute('style', 'display: none;');
  document.head.appendChild(template.content);
}
appendBasicThemeToHead();
